import { useAppDispatch } from '@features';
import { Checkbox } from '@repo/shadcn';
import { CellContext, ColumnDef } from '@tanstack/react-table';

import {
    addExpiryAdjustmentItem,
    removeExpiryAdjustmentItem,
} from '@/features/slice/inventory';

const CheckboxCell = ({ row }: CellContext<any, any>) => {
    const dispatch = useAppDispatch();

    const handleCheckChange = (checked: boolean) => {
        if (!checked) {
            // Remove item from expiry adjustment
            dispatch(removeExpiryAdjustmentItem(row.original.purchase_item_id));
            return;
        }

        if (checked) {
            dispatch(
                addExpiryAdjustmentItem({
                    productVariationId: row.original.product_variation_id,
                    purchaseItemId: row.original.purchase_item_id,
                    quantity: row.original.total_quantity,
                    productName: row.original.product_name,
                    brandName: row.original.brand_name,
                    expirationDate: row.original.expiration_date,
                    purchasePrice: row.original.purchase_price,
                    wholesalePrice: row.original.wholesale_price,
                    retailPrice: row.original.retail_price,
                    updatedPurchasePrice: row.original.purchase_price,
                }),
            );
        }
    };

    return <Checkbox className={'w-4'} onCheckedChange={handleCheckChange} />;
};

export const expiredStockListColumns: Array<ColumnDef<any>> = [
    {
        accessorKey: 'checkbox',
        header: () => <div className={'w-4'} />,

        cell: CheckboxCell,
    },

    {
        accessorKey: 'product_name',
        header: () => <div>Product Name</div>,
        cell: ({ row }) => <div>{row.original.product_name}</div>,
    },

    {
        accessorKey: 'brand_name',
        header: () => <div>Brand Name</div>,
        cell: ({ row }) => <div>{row.original.brand_name}</div>,
    },

    {
        accessorKey: 'current_stock',
        header: () => <div className={'text-right'}>Expired Stock</div>,
        cell: ({ row }) => (
            <div className={'text-right'}>{row.original.total_quantity}</div>
        ),
    },

    // {
    //     accessorKey: 'alert_quantity',
    //     header: () => <div className={'text-right'}>Alert Quantity</div>,
    //     cell: ({ row }) => (
    //         <div className={'text-right'}>{row.original.alert_quantity}</div>
    //     ),
    // },
    {
        accessorKey: 'expiry_date',
        header: () => <div className={'text-right'}>Expiry Date</div>,
        cell: ({ row }) => (
            <div className={'text-right'}>
                {new Date(row.original.expiration_date).toLocaleDateString()}
            </div>
        ),
    },
];
